import { render, staticRenderFns } from "./CompositeFormCtrl.vue?vue&type=template&id=d398bd8c&scoped=true&"
import script from "./CompositeFormCtrl.vue?vue&type=script&lang=js&"
export * from "./CompositeFormCtrl.vue?vue&type=script&lang=js&"
import style0 from "./CompositeFormCtrl.vue?vue&type=style&index=0&id=d398bd8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d398bd8c",
  null
  
)

export default component.exports